// extracted by mini-css-extract-plugin
var _1 = "o2VlC";
export { _1 as "menuItem" }
